module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showing),
      expression: "showing"
    }],
    staticClass: "lightbox-2",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "lightbox-content-container"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "lightbox-decorations-container"
  }, [_c('button', {
    staticClass: "lightbox-close",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })]), _vm._v(" "), _vm._t("decorations")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c2348c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/lightbox/index.vue
// module id = 1998
// module chunks = 2